const defaultState = {
  isLoading: false,
  isError: false,
  isSuccess: false,
  error: '',
};

export default (state = defaultState, action = {}) => {
  switch (action.type) {
    case 'DATA_ANNOTATION_PHOTO_DOCUMENT_DELETE_INIT': {
      return {
        ...state,
        isLoading: false,
        isError: false,
        isSuccess: false,
        error: '',
      };
    }
    case 'DATA_ANNOTATION_PHOTO_DOCUMENT_DELETE_PENDING': {
      return {
        ...state,
        isLoading: true,
        isSuccess: false,
        isError: false,
        error: '',
      };
    }
    case 'DATA_ANNOTATION_PHOTO_DOCUMENT_DELETE_SUCCESS': {
      return {
        ...state,
        isLoading: false,
        isSuccess: true,
        isError: false,
        error: '',
      };
    }
    case 'DATA_ANNOTATION_PHOTO_DOCUMENT_DELETE_ERROR': {
      return {
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        error:
          action && action.err && action.err.message ? action.err.message : '',
      };
    }
    default:
      return state;
  }
};
